import { type Ref, ref } from 'vue'
import { defineStore } from 'pinia'

export const useEditorStore = defineStore('editor', () => {
	const selector: any = ref(null)
	const enterSelector: any = ref(null)
	const functionStartTarget: any = ref(null)
	const functionTarget: any = ref(null)
	const cellTarget: any = ref(null)
	const dragList: any = ref([])
	const tableSelector: any = ref(null)
	const isContextMenu: any = ref(false)
	const viewBlockList: any = ref([])
	const blockList: any = ref([])
	const startBlockIndex: any = ref(0)
	const endBlockIndex: any = ref(0)
	const blockHeightList: any = ref([])
	const overBlockIndex: Ref<number, number> = ref(0)
	const newBlockId: Ref<string, string> = ref('')
	const prevHeightPosition: Ref<number, number> = ref(0)
	const scrollCount: Ref<number, number> = ref(0)
	const filterList: any = ref(['SUM', 'AVG', 'AVERAGE', 'STDEV', 'FLOOR'])
	const functionList: any = ref([
		'FLOOR',
		'LN',
		'LOG',
		'MOD',
		'ROUND',
		'SQRT',
		'SUM',
		'AVERAGE',
		'AVG',
		'COUNT',
		'MAX',
		'MIN',
		'STDEV',
		'CONCATENATE',
		'CONCAT',
		'LEN',
		'MID',
		'SUBSTITUTE',
		'AND',
		'OR',
		'IF',
		'LOOKUP',
		'TEXTJOIN',
		'FACT',
		'ISBLANK',
		'ISERROR',
		'LEFT',
		'RIGHT',
		'PRODUCT',
		'TRUE',
		'FALSE',
		'ISNUMBER',
		'POWER',
		'SLOPE',
		'INTERCEPT',
	])
	const isFunctionList = ref(false)
	const functionListTimeout: any = ref(null)
	const isFunctionActive: any = ref(false)
	const savedRange: any = ref(null)
	const changeRange: any = ref(null)
	const functionKeyType: any = ref('')
	const positionWidth: any = ref(0)
	const positionHeight: any = ref(0)
	const noteUid: any = ref(localStorage.getItem('noteUid') || '')
	const tableBlockTemp: any = ref([])
	const participantsList: any = ref([])
	const isWrite: any = ref(false)
	const noteType: any = ref('Project')
	const isTemplateOpen: any = ref(false)
	const isLoadNote: any = ref(false)
	const isImageSize: any = ref(false)
	const isImageResize: any = ref(false)
	const oldBlockUid: any = ref('')
	const chartDataList: any = ref({})
	const isFocusOut: any = ref(false)
	const cumulativeHeights: any = ref([0])
	const tableDropboxSelectList: any = ref([])
	const reviewList: any = ref([])
	const reviewListBlockUid: any = ref('')
	const undoStack: any = ref([])
	const redoStack: any = ref([])
	const isFirst: any = ref(false)
	const itemHeights: any = ref([])
	const chartData: any = ref([])
	const isHandlerTime: any = ref(null)
	const isUndoRedoInProgress: any = ref(false)
	const lastUndoRedoTime: Ref<number> = ref(0)
	const isPasting: any = ref(false)
	const isTemplateAdding: any = ref(false)
	const isReopen: any = ref(false)
	const isPdfOpen: any = ref(false)
	const pdfUrl: any = ref('')
	const pdfName: any = ref('')

	return {
		selector,
		enterSelector,
		cellTarget,
		dragList,
		isContextMenu,
		tableSelector,
		blockList,
		viewBlockList,
		startBlockIndex,
		endBlockIndex,
		blockHeightList,
		overBlockIndex,
		prevHeightPosition,
		scrollCount,
		filterList,
		functionList,
		isFunctionList,
		functionListTimeout,
		isFunctionActive,
		savedRange,
		changeRange,
		functionKeyType,
		functionStartTarget,
		positionWidth,
		positionHeight,
		noteUid,
		newBlockId,
		oldBlockUid,
		tableBlockTemp,
		participantsList,
		isWrite,
		noteType,
		isTemplateOpen,
		functionTarget,
		isLoadNote,
		isImageSize,
		chartDataList,
		isFocusOut,
		cumulativeHeights,
		tableDropboxSelectList,
		reviewList,
		reviewListBlockUid,
		undoStack,
		redoStack,
		isImageResize,
		isFirst,
		itemHeights,
		chartData,
		isHandlerTime,
		isUndoRedoInProgress,
		lastUndoRedoTime,
		isPasting,
		isTemplateAdding,
		isReopen,
		isPdfOpen,
		pdfUrl,
		pdfName,
	}
})
